import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <p className="eyebrow">Welcome to D.C.</p>
        <h1>Your Gateway to Washington, D.C.</h1>
        <p className="lede">
          Discover the heart of the nation with our comprehensive guides and insider tips for exploring Washington, D.C. From iconic landmarks to hidden gems, we have everything you need to make the most of your visit.
        </p>
        <div className="cta-row">
          <a href="/guides" target="_self">
            Explore Our Guides
          </a>
          <a href="/about" target="_self" className="secondary">
            Learn More About Us
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Plan Your Visit</h2>
          <p>
            Get the latest information on attractions, events, and travel tips to ensure a seamless experience in the capital.
          </p>
        </article>
        <article>
          <h2>Experience D.C.</h2>
          <p>
            Immerse yourself in the rich history and vibrant culture of Washington, D.C. with our curated experiences and recommendations.
          </p>
        </article>
        <article>
          <h2>Stay Informed</h2>
          <p>
            Sign up for our newsletter to receive updates on new guides, special events, and exclusive offers tailored for your visit.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;